const PRODUCT_CONSTANTS = {
  MODALHEADERTEXT: 'selectOption',
  UPLIFTPLACEHOLDER: 'upSize',
  CONFIRMBUTTONTXT: 'confirmSelection',
  REGULAR: 'Regular',
  ADDTOCART: 'addToCart',
  UPDATECART: 'updateCart',
  SETFLAGCASE: {
    DEFAULT: 'default',
    FROMEDIT: 'fromEdit',
    ITEMINCLUDES: 'itemIncludes',
  },
  SINGLE: 'single',
};
export default PRODUCT_CONSTANTS;
